import React from "react";
import { Link } from "react-router-dom";
import { Typography, Card, Button } from "antd";
import {
  FileDoneOutlined,
  FolderOpenOutlined,
  FileExcelOutlined,
} from '@ant-design/icons';

import INTERNAL_LINKS from "../../enum/InternalLinks";

import "./style.scss";

const { Title } = Typography;

const HomePage = () => {
  return (<>
    <Title level={3}>Home Page / Página de Inicio</Title>
    <div className="home-container">
      <Card title="Surveys / Entrevistas" bordered={true} style={{ width: 300 }}>
        <div className="card-content">
          <FileDoneOutlined style={{ fontSize: '64px' }} />
          <Button type="primary"><Link to={INTERNAL_LINKS.SURVEY_HOME} >Join / Entrar</Link></Button>
        </div>
      </Card>

      <Card title="Global/Regional Surveys / Global/Regional Entrevistas" bordered={true} style={{ width: 300 }}>
        <div className="card-content">
          <FileDoneOutlined style={{ fontSize: '64px' }} />
          <Button type="primary"><Link to={INTERNAL_LINKS.GLOBAL_REGIONAL_SURVEY_HOME} >Join / Entrar</Link></Button>
        </div>
      </Card>

      <Card title="Files / Archivos" bordered={true} style={{ width: 300 }}>
        <div className="card-content">
          <FolderOpenOutlined style={{ fontSize: '64px' }} />
          <Button type="primary"><Link to={INTERNAL_LINKS.FILES} >Join / Entrar</Link></Button>
        </div>
      </Card>

      <Card title="Reports / Reportes" bordered={true} style={{ width: 300 }}>
        <div className="card-content">
          <FileExcelOutlined style={{ fontSize: '64px' }} />
          <Button type="primary"><Link to={INTERNAL_LINKS.REPORTS} >Join / Entrar</Link></Button>
        </div>
      </Card>
    </div>
  </>);
};

export default HomePage;